export default "/images/vendor/@coreui/icons/svg/flag/cif-no.svg?5710feaafcdd563a98ac5545c085c449";